module.exports = __webpack_public_path__ + "img/performance-school-icon1.fbab7338.png";